// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"461":"3307f947","593":"d89c05cb","807":"8a13afb0","928":"14e7ebd2"}[chunkId] + ".css";
};